import type { ReactElement, ReactNode } from 'react'
import { Box } from '@mui/material'

export type DisabledSectionProps = {
  disabled: boolean
  children: ReactNode
}

/**
 * Greys out a block of form content and takes it out of reach while some
 * precondition is unmet.
 *
 * Rendered as a `fieldset`, which is what actually disables the native inputs
 * and buttons inside it, including for keyboard users. `pointerEvents` covers
 * the controls that render as a div rather than a native input - a MUI select
 * would otherwise still open its menu on click.
 */
export const DisabledSection = ({ disabled, children }: DisabledSectionProps): ReactElement => (
  <Box
    component="fieldset"
    disabled={disabled}
    aria-disabled={disabled || undefined}
    sx={{
      // A fieldset carries browser defaults that would break the surrounding
      // layout; strip them and keep it a plain block.
      border: 0,
      margin: 0,
      padding: 0,
      minInlineSize: 0,
      ...(disabled && { opacity: 0.45, pointerEvents: 'none' }),
    }}
  >
    {children}
  </Box>
)
